import React from 'react';
import { useTranslation } from 'react-i18next';
import { Filter } from 'grommet-icons';
import { Box, Text } from '/src/components';

export const NoFiltersMessage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box flex align="center" justify="center" gap="small" pad={{ horizontal: '1.5rem', vertical: '3rem' }}>
      <Filter size="32px" color="brand" />
      <Text size="medium" textAlign="center" fontFamily="Lato, sans-serif">
        {t('apiData:noFilters')}
      </Text>
    </Box>
  );
};
